import { ShieldAlert } from 'lucide-react'
import { cuiBannerText, type CuiCategory } from '@/services/security/accessControl'
import { cn } from '@/lib/utils'

/**
 * The marking shown at the top of a controlled (CUI) request or document, on
 * screen and in print (`print:` keeps it on paper and in a saved PDF).
 */
export function CuiBanner({ marking, categories, className, note }: {
  marking?: string | null
  categories?: CuiCategory[]
  className?: string
  note?: string
}) {
  return (
    <div
      role="note"
      aria-label="Controlled information marking"
      data-cui-banner
      className={cn(
        'flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-amber-900 print:border-black print:bg-white print:text-black',
        className,
      )}
    >
      <ShieldAlert size={14} className="mt-px shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <div>{cuiBannerText(marking, categories)}</div>
        {note && <div className="mt-0.5 font-normal normal-case tracking-normal text-amber-800 print:text-black">{note}</div>}
      </div>
    </div>
  )
}

/** A small chip for lists: this row is controlled. */
export function CuiChip({ marking, className }: { marking?: string | null; className?: string }) {
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-amber-800', className)}
      title="Controlled information: only the CUI group can see this record"
    >
      <ShieldAlert size={10} aria-hidden="true" /> {(marking ?? '').trim() || 'CUI'}
    </span>
  )
}
